var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHexLogoinline = function SvgHexLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 20,
    viewBox: "0 0 52 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0v6.973H7V0H0v20h7V10h2v10h7V0H9Zm9 20h16v-8h-7v5h-2v-7h9V0H18v20Zm7-13V3h2v4h-2Zm20 0V0h7v5l-3 3.5 3 3.5v8h-7V9.973h-2V20h-7v-8l3-3.5L36 5V0h7v7h2Z",
    fill: "#473982"
  })));
};
export default SvgHexLogoinline;